/**
 * @generated SignedSource<<0d090e4f9ccda5e1a21420f26128f5af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastDeviceScheduleItemWeekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type StorecastDeviceSetDashboardScheduleInputItem = {
  endAt: string;
  startAt: string;
  storecastId: string;
  weekdays: ReadonlyArray<StorecastDeviceScheduleItemWeekday>;
};
export type StorecastScreenAdminAddScheduleItemMutation$variables = {
  deleteItems?: ReadonlyArray<string> | null;
  items?: ReadonlyArray<StorecastDeviceSetDashboardScheduleInputItem> | null;
  screenId: string;
};
export type StorecastScreenAdminAddScheduleItemMutation$data = {
  readonly storecast: {
    readonly setScreenDashboardSchedule: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"StorecastScreenAdminSchedule_StorecastScreen">;
    };
  };
};
export type StorecastScreenAdminAddScheduleItemMutation = {
  response: StorecastScreenAdminAddScheduleItemMutation$data;
  variables: StorecastScreenAdminAddScheduleItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deleteItems"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "items"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "addItems",
    "variableName": "items"
  },
  {
    "kind": "Variable",
    "name": "deleteItems",
    "variableName": "deleteItems"
  },
  {
    "kind": "Variable",
    "name": "screenId",
    "variableName": "screenId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminAddScheduleItemMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastMutation",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "setScreenDashboardSchedule",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StorecastScreenAdminSchedule_StorecastScreen"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastScreenAdminAddScheduleItemMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastMutation",
        "kind": "LinkedField",
        "name": "storecast",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "setScreenDashboardSchedule",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StorecastDeviceSetDashboardScheduleItem",
                "kind": "LinkedField",
                "name": "scheduledStorecasts",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dashboard",
                    "kind": "LinkedField",
                    "name": "storecast",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekdays",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bfcaa50e4cae9a679fc8c757add7d2c5",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminAddScheduleItemMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminAddScheduleItemMutation(\n  $screenId: ID!\n  $items: [StorecastDeviceSetDashboardScheduleInputItem!]\n  $deleteItems: [ID!]\n) {\n  storecast {\n    setScreenDashboardSchedule(addItems: $items, deleteItems: $deleteItems, screenId: $screenId) {\n      id\n      ...StorecastScreenAdminSchedule_StorecastScreen\n    }\n  }\n}\n\nfragment StorecastScreenAdminSchedule_StorecastScreen on StorecastScreen {\n  id\n  scheduledStorecasts {\n    id\n    storecast {\n      id\n      name\n    }\n    startAt\n    endAt\n    weekdays\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6f1940756a96ef11f00ca9424730cd8";

export default node;
